/*Modal Rank Guide */
export const handelOpenModalRankGuide = () => ({
    type: 'OPEN_MODAL_RANK_GUIDE'
});
export const handelCloseModalRankGuide = () => ({
    type: 'CLOSE_MODAL_RANK_GUIDE'
});